import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=0a84f0d7"
import script from "./Relations.vue?vue&type=script&lang=ts"
export * from "./Relations.vue?vue&type=script&lang=ts"
import style0 from "./Relations.vue?vue&type=style&index=0&id=0a84f0d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports